import { SliderWithCommit } from "@/baseComponents";

import { useFilterContext } from "../FilterContext";

const FilterItemTax = () => {
  const { filterData, setFilterData, filterOptions } = useFilterContext();

  // 提交最终值
  const handleSliderCommit = (_, v: number | number[]) => {
    if (typeof v === "number") {
      setFilterData({
        tax: (v === filterOptions.taxRange[1] ? -1 : v) as number,
      });
    }
  };

  return (
    <div className="pt-[40px] pb-[12px] px-[40px]">
      <SliderWithCommit
        defaultValue={50}
        getAriaLabel={() => "Default"}
        valueLabelDisplay="on"
        min={filterOptions.taxRange[0] || 0}
        max={filterOptions.taxRange[1] || 0}
        key={filterOptions.taxRange[1]}
        value={filterData.tax === -1 ? filterOptions.taxRange[1] || 0 : filterData.tax}
        valueLabelFormat={(v: number) => `$${v}`}
        onChangeCommitted={handleSliderCommit}
      />
    </div>
  );
};

export default FilterItemTax;
